<template>
  <div class="temperature-slider">
    <vue-slider v-if="is_slider" :width="'80%'" :tooltipStyle="slider_styles.tooltipStyle" :min="min" :max="max"
      :bgStyle="slider_styles.bgStyle" :processStyle="slider_styles.processStyle" @drag="filterVectors()"
      v-model="value"></vue-slider>
    <p class="heading-secondary is-medium-14-500-19 temperature-slider__label">
      {{ localization("app-temperature-difference", "Temperature Difference") }}
    </p>
  </div>
</template>
<script>
import { mapGetters, mapState, mapMutations } from "vuex";
import vueSlider from "vue-slider-component";
const slider_styles = {
  bgStyle: {
    backgroundColor: "#d6dffb",
    height: "5px",
  },
  tooltipStyle: {
    backgroundColor: "#fff",
    borderColor: "#344257",
    color: "#171e48",
    fontFamily: "Barlow",
    fontSize: "13px",
    fontWeight: "600",
    width: "30px",
    height: "27px",
    boxShadow: "0 4px 6px 0 rgba(60, 80, 100, 0.2)",
    border: "solid 1.5px #3c5064",
    borderRadius: "6px",
  },
  processStyle: {
    backgroundColor: "#3c5064",
    borderRadius: "255px",
    boxShadow: "0px 2px 10px 0px rgba(60, 80, 100, 0.2)",
  },
};
// #344257
export default {
  data() {
    return {
      is_slider: false,
      value: [0, 50],
      slider_styles,
      min: 0,
      max: 100,
    };
  },
  watch: {
    view_details(val) {
      this.is_slider = false;
      if (val.metrics && val.metrics.temperature_difference) {
        this.min = parseInt(Math.min(val.metrics.temperature_difference.min || 0, 0));
        this.max = parseInt(Math.max(val.metrics.temperature_difference.max || 0, 100));
        this.value = [this.min, this.max];
        this.is_slider = true;
      }
    },
  },
  components: {
    vueSlider,
  },
  computed: {
    ...mapState(["draw", "view_details"]),
  },
  methods: {
    ...mapMutations(["UPDATE_TEMPERATURE_FILTERED_FEATURES"]),
    filterVectors() {
      this.UPDATE_TEMPERATURE_FILTERED_FEATURES(this.value);
    },
  },
};
</script>
<style lang="scss">
.vue-slider-component {
  margin: 0 auto;
}

.vue-slider-component .vue-slider-dot .vue-slider-dot-handle {
  width: 18px;
  height: 18px;
  object-fit: contain;
  box-shadow: 0 5px 10px 0 rgba(60, 80, 100, 0.2);
  border: solid 3px #3c5064;
  background-color: #ffffff;
  margin-top: -2px;
}

.temperature-slider {
  font-family: Barlow-Regular;

  .heading-secondary.temperature-slider__label {
    color: #171e48;
    margin-top: 0.7rem;
    text-transform: capitalize;
    font-weight: bold;
  }

  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1rem;
  margin-top: 4rem;
}
</style>
